import React, {Fragment, useState, useEffect} from 'react';
import 'fontsource-roboto';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import useIsMountedRef from './../Components/useIsMountedRef';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {Link} from 'react-router-dom';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
// import ReactExport from 'react-data-export';

import * as XLSX from 'xlsx';
import {saveAs} from 'file-saver';

import AddIcon from '@material-ui/icons/Add';

import Warning from '../Components/Warning';

const useStyles = makeStyles(theme => ({
  errorMain: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.main
  },
  errorLight: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.light
  },
  errorDark: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.dark
  },
  warningMain: {
    color: theme.palette.warning.contrastText,
    backgroundColor: theme.palette.warning.main
  },
  warningLight: {
    color: theme.palette.warning.contrastText,
    backgroundColor: theme.palette.warning.light
  },
  warningDark: {
    color: theme.palette.warning.contrastText,
    backgroundColor: theme.palette.warning.dark
  },
  infoMain: {
    color: theme.palette.info.contrastText,
    backgroundColor: theme.palette.info.main
  },
  infoLight: {
    color: theme.palette.info.contrastText,
    backgroundColor: theme.palette.info.light
  },
  infoDark: {
    color: theme.palette.info.contrastText,
    backgroundColor: theme.palette.info.dark
  },
  successMain: {
    color: theme.palette.success.contrastText,
    backgroundColor: theme.palette.success.main
  },
  successLight: {
    color: theme.palette.success.contrastText,
    backgroundColor: theme.palette.success.light
  },
  successDark: {
    color: theme.palette.success.contrastText,
    backgroundColor: theme.palette.success.dark
  },
  divider: {
    margin: theme.spacing(.5, 0)
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: theme.spacing(0.5)
  },
  cardHeader: {
    padding: theme.spacing(1, 2, 1)
  },
  cardContent: {
    flexGrow: 1,
    padding: theme.spacing(1),
    '&:last-child': {
      paddingBottom: theme.spacing(1)
    }
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  }
}));

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function Dashboard(props) {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));

  const idReceptionLabelRef = React.createRef();

  const classes = useStyles();
  const ajax = props.ajax;

  const isMountedRef = useIsMountedRef();

  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);
  const [report, setReport] = useState({
    op: '',
    idPartner: '0',
    dateStart: new Date().toISOString().split('T')[0],
    dateStop: new Date().toISOString().split('T')[0]
  });
  const [idReceptionLabel, setIdReceptionLabel] = useState('');

  const reports = [
    {op: 'resellerReceptionsHistory'   , caption: 'Raport expedieri probe (temperaturi)', partnerRequired: true},
    {op: 'resellerReceptionsUnreceived', caption: 'Raport probe neprimite de laborator' , partnerRequired: true}
  ];

  useEffect(() => {
    ajax('resellerDashboard')
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data);

        setIsLoaded(true);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleMarkAntigenAsReportedToDsp = idReceptionsSL => () => {
    ajax('resellerMarkAntigenAsReportedToDsp', {
      idReceptionsSL: idReceptionsSL
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          const sheet = XLSX.utils.json_to_sheet(data.antigen);
          var csv = XLSX.utils.sheet_to_csv(sheet, {FS: ';'});
          const blob = new Blob([csv], {type: 'text/plain;charset=UTF-8'});
          saveAs(blob, `Raportare antigen - Sunmed ${(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60 * 1000))).toISOString()}.csv`);

          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  return (
    <Container maxWidth='md'>
      <Typography variant='h5'>Receptie</Typography>
      <Typography color='textSecondary'>{props.user.partner}</Typography>
      <Divider className={classes.divider} />

      {!isLoaded &&
        <Box display='block' align='center'>
          <CircularProgress />
        </Box>
      }

      {isLoaded && !!~props.user.permissions.indexOf('partnerDashboardReceptions') &&
        <Fragment>
          <Card className={classes.card}>
            <CardHeader
              title={<Typography variant='subtitle1' display='inline'>Sumar recoltari</Typography>}
            />
            <CardContent className={classes.cardContent}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <Link to='/Receptions' className={classes.link}>
                    <Card className={classes.card}>
                      <CardContent className={`${classes.cardContent} ${Boolean(parseInt(data.receptions.unsent)) ? classes.errorMain : ''}`}>
                        <Typography component='div' align='center'>Neexpediate catre laborator</Typography>
                        <Typography variant='subtitle2' align='center'>{data.receptions.unsent}</Typography>
                      </CardContent>
                    </Card>
                  </Link>
                </Grid>
                <Grid item xs={6} sm={4}>
                  <Link to='/Receptions' className={classes.link}>
                    <Card className={classes.card}>
                      <CardContent className={`${classes.cardContent} ${Boolean(parseInt(data.receptions.sent)) ? classes.warningMain : ''}`}>
                      <Typography component='div' align='center'>Expediate si neprimite de laborator</Typography>
                        <Typography variant='subtitle2' align='center'>{data.receptions.sent}</Typography>
                      </CardContent>
                    </Card>
                  </Link>
                </Grid>
                <Grid item xs={6} sm={4}>
                  <Link to='/Receptions' className={classes.link}>
                    <Card className={classes.card}>
                      <CardContent className={`${classes.cardContent} ${Boolean(parseInt(data.receptions.received)) ? classes.infoMain : ''}`}>
                      <Typography component='div' align='center'>Primite si date in lucru la laborator</Typography>
                        <Typography variant='subtitle2' align='center'>{data.receptions.received}</Typography>
                      </CardContent>
                    </Card>
                  </Link>
                </Grid>
              </Grid>
            </CardContent>
            <CardContent className={classes.cardContent}>
              <Typography variant='caption' color='secondary'>* Prin apasarea oricarui buton din cele trei de mai sus se ajunge in sectiunea de RECOLTARI.</Typography>
            </CardContent>
          </Card>

          {!!~props.user.permissions.indexOf('partnerDashboardReports') &&
            <Card className={classes.card}>
              <CardHeader
                title={<Typography variant='subtitle1'>Rapoarte rapide</Typography>}
              />
              <CardContent className={classes.cardContent}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <TextField margin='none' required select
                      label='Raport'
                      placeholder='Raport'
                      value={report.op}
                      onChange={e => setReport({
                        ...report, op: e.target.value, idPartner: '0'
                      })}
                    >
                      {reports.map(option => (
                        <MenuItem key={option.op} value={option.op}>
                          {option.caption}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField margin='none' required select
                      disabled={!Boolean(report.op) || !reports.filter(item => item.op === report.op)[0].partnerRequired}
                      label='Partener'
                      placeholder='Partener'
                      value={report.idPartner}
                      onChange={e => setReport({...report, idPartner: e.target.value})}
                    >
                      <MenuItem key='0' value='0'>Toti partenerii</MenuItem>
                      {data.partners.filter(partner => !Boolean(props.user.idPartner) || partner.id === props.user.idPartner).map(option => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.partner}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <TextField margin='none' required type='date' inputProps={{max: report.dateStop}}
                      disabled={!Boolean(report.op)}
                      label='De la data'
                      placeholder='De la data'
                      value={report.dateStart}
                      onChange={e => setReport({...report, dateStart: e.target.value})}
                    />
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <TextField margin='none' required type='date' inputProps={{min: report.dateStart, max: new Date().toISOString().split('T')[0]}}
                      disabled={!Boolean(report.op)}
                      label='Pana la data'
                      placeholder='Pana la data'
                      value={report.dateStop}
                      onChange={e => setReport({...report, dateStop: e.target.value})}
                    />
                  </Grid>
                  {mdUp &&
                    <Grid item md={4}></Grid>
                  }
                  <Grid item xs={12} sm={4} md={2}>
                    <Button fullWidth variant='contained' color='primary' size='large'
                      disabled={!Boolean(report.op)}
                      onClick={() => window.open(`${props.url.download}?op=${report.op}&idPartner=${report.idPartner}&dateStart=${report.dateStart}&dateStop=${report.dateStop}&SID=${props.user.sessid}&variant=live`)}
                    >
                      Genereaza
                    </Button>
                  </Grid>

                  {!Boolean(props.user.idPartner) &&
                    <Grid item xs={12} md={6}>
                      <Button fullWidth variant='contained' color='primary' size='large'
                        disabled={!Boolean(data.antigen.length)}
                        onClick={handleMarkAntigenAsReportedToDsp(data.antigen.map(row => row.id))}
                      >
                        Descarca CSV antigeni SARS-CoV-2
                      </Button>
                    </Grid>
                  }
                </Grid>
              </CardContent>
            </Card>
          }

          {!!~props.user.permissions.indexOf('partnerDashboardPrintLabels') &&
            <Card className={classes.card}>
              <CardHeader
                title={<Typography variant='subtitle1'>Tiparire etichete</Typography>}
              />
              <CardContent className={classes.cardContent}>
                <Grid container spacing={1}>
                  <Grid item xs={8} md={6}>
                    <TextField margin='none' required inputRef={idReceptionLabelRef}
                      label='Cod proba/probe'
                      placeholder='Cod proba/probe'
                      value={idReceptionLabel}
                      onChange={e => {
                        if (e.target.value === '' || /^[0-9\b]+$/.test(e.target.value))
                          setIdReceptionLabel(e.target.value);
                      }}
                      onKeyDown={e => {
                        switch (e.key) {
                          case 'ArrowUp':
                            setIdReceptionLabel(+idReceptionLabel + 1);
                            break;
                          case 'ArrowDown':
                            setIdReceptionLabel(Math.max(1, +idReceptionLabel - 1));
                            break;
                          case 'Enter':
                            if (!Boolean(idReceptionLabel))
                              return;
                            window.open(`${props.url.download}?op=etichete&id_receptie=${idReceptionLabel}`);
                            idReceptionLabelRef.current.select();
                            idReceptionLabelRef.current.focus();
                            break;

                            default:
                              break;
                        }
                      }}
                    />
                  </Grid>
                  {mdUp &&
                    <Grid item md={4}></Grid>
                  }
                  <Grid item xs={4} md={2}>
                    <Button fullWidth variant='contained' color='primary' size='large'
                      disabled={!Boolean(idReceptionLabel)}
                      onClick={() => {
                        window.open(`${props.url.download}?op=etichete&id_receptie=${idReceptionLabel}`);
                        idReceptionLabelRef.current.select();
                        idReceptionLabelRef.current.focus();
                      }}
                    >
                      Genereaza
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant='caption' color='secondary'>* Folositi sageata in sus sau in jos pentru receptiile adiacente si ENTER pentru generarea etichetelor</Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          }

          {!!~props.user.permissions.indexOf('partnerDashboardFinancial') &&
            <Card className={classes.card}>
              <CardHeader
                title={<Typography variant='subtitle1'>Situatie financiara sumara</Typography>}
              />
              <CardContent className={classes.cardContent}>
                <Grid container spacing={1}>
                  <Grid item xs={12}><Typography variant='subtitle2'>Pentru ziua curenta</Typography></Grid>
                  <Grid item xs={4}>
                    <Card className={classes.card} style={{cursor: 'pointer'}}
                      onClick={() => window.open(`${props.url.download}?op=resellerReportToday&SID=${props.user.sessid}&variant=live`)}
                    >
                      <CardContent className={`${classes.cardContent} ${classes.infoLight}`}>
                        <Typography component='div' align='center'>Venituri</Typography>
                        <Typography variant='subtitle2' align='center'>{data.today.price} RON</Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={4}>
                    <Card className={classes.card} style={{cursor: 'pointer'}}
                      onClick={() => window.open(`${props.url.download}?op=resellerReportToday&SID=${props.user.sessid}&variant=live`)}
                    >
                      <CardContent className={`${classes.cardContent} ${classes.errorLight}`}>
                        <Typography component='div' align='center'>Cheltuieli</Typography>
                        <Typography variant='subtitle2' align='center'>{data.today.cost} RON</Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={4}>
                    <Card className={classes.card} style={{cursor: 'pointer'}}
                      onClick={() => window.open(`${props.url.download}?op=resellerReportToday&SID=${props.user.sessid}&variant=live`)}
                    >
                      <CardContent className={`${classes.cardContent} ${classes.successLight}`}>
                        <Typography component='div' align='center'>Profit</Typography>
                        <Typography variant='subtitle2' align='center'>{data.today.profit} RON</Typography>
                      </CardContent>
                    </Card>
                  </Grid>

                  <Grid item xs={12}><Typography variant='subtitle2'>Pentru ultimele 7 zile</Typography></Grid>
                  <Grid item xs={4}>
                    <Card className={classes.card} style={{cursor: 'pointer'}}
                      onClick={() => window.open(`${props.url.download}?op=resellerReportWeekly&SID=${props.user.sessid}&variant=live`)}
                    >
                      <CardContent className={`${classes.cardContent} ${classes.infoLight}`}>
                        <Typography component='div' align='center'>Venituri</Typography>
                        <Typography variant='subtitle2' align='center'>{data.weekly.price} RON</Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={4}>
                    <Card className={classes.card} style={{cursor: 'pointer'}}
                      onClick={() => window.open(`${props.url.download}?op=resellerReportWeekly&SID=${props.user.sessid}&variant=live`)}
                    >
                      <CardContent className={`${classes.cardContent} ${classes.errorLight}`}>
                        <Typography component='div' align='center'>Cheltuieli</Typography>
                        <Typography variant='subtitle2' align='center'>{data.weekly.cost} RON</Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={4}>
                    <Card className={classes.card} style={{cursor: 'pointer'}}
                      onClick={() => window.open(`${props.url.download}?op=resellerReportWeekly&SID=${props.user.sessid}&variant=live`)}
                    >
                      <CardContent className={`${classes.cardContent} ${classes.successLight}`}>
                        <Typography component='div' align='center'>Profit</Typography>
                        <Typography variant='subtitle2' align='center'>{data.weekly.profit} RON</Typography>
                      </CardContent>
                    </Card>
                  </Grid>

                  <Grid item xs={12}><Typography variant='subtitle2'>Pentru luna curenta</Typography></Grid>
                  <Grid item xs={4}>
                    <Card className={classes.card} style={{cursor: 'pointer'}}
                      onClick={() => window.open(`${props.url.download}?op=resellerReportThisMonth&SID=${props.user.sessid}&variant=live`)}
                    >
                      <CardContent className={`${classes.cardContent} ${classes.infoLight}`}>
                        <Typography component='div' align='center'>Venituri</Typography>
                        <Typography variant='subtitle2' align='center'>{data.thisMonth.price} RON</Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={4}>
                    <Card className={classes.card} style={{cursor: 'pointer'}}
                      onClick={() => window.open(`${props.url.download}?op=resellerReportThisMonth&SID=${props.user.sessid}&variant=live`)}
                    >
                      <CardContent className={`${classes.cardContent} ${classes.errorLight}`}>
                        <Typography component='div' align='center'>Cheltuieli</Typography>
                        <Typography variant='subtitle2' align='center'>{data.thisMonth.cost} RON</Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={4}>
                    <Card className={classes.card} style={{cursor: 'pointer'}}
                      onClick={() => window.open(`${props.url.download}?op=resellerReportThisMonth&SID=${props.user.sessid}&variant=live`)}
                    >
                      <CardContent className={`${classes.cardContent} ${classes.successLight}`}>
                        <Typography component='div' align='center'>Profit</Typography>
                        <Typography variant='subtitle2' align='center'>{data.thisMonth.profit} RON</Typography>
                      </CardContent>
                    </Card>
                  </Grid>

                  <Grid item xs={12}><Typography variant='subtitle2'>Pentru luna anterioara</Typography></Grid>
                  <Grid item xs={4}>
                    <Card className={classes.card} style={{cursor: 'pointer'}}
                      onClick={() => window.open(`${props.url.download}?op=resellerReportLastMonth&SID=${props.user.sessid}&variant=live`)}
                    >
                      <CardContent className={`${classes.cardContent} ${classes.infoLight}`}>
                        <Typography component='div' align='center'>Venituri</Typography>
                        <Typography variant='subtitle2' align='center'>{data.lastMonth.price} RON</Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={4}>
                    <Card className={classes.card} style={{cursor: 'pointer'}}
                      onClick={() => window.open(`${props.url.download}?op=resellerReportLastMonth&SID=${props.user.sessid}&variant=live`)}
                    >
                      <CardContent className={`${classes.cardContent} ${classes.errorLight}`}>
                        <Typography component='div' align='center'>Cheltuieli</Typography>
                        <Typography variant='subtitle2' align='center'>{data.lastMonth.cost} RON</Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={4}>
                    <Card className={classes.card} style={{cursor: 'pointer'}}
                      onClick={() => window.open(`${props.url.download}?op=resellerReportLastMonth&SID=${props.user.sessid}&variant=live`)}
                    >
                      <CardContent className={`${classes.cardContent} ${classes.successLight}`}>
                        <Typography component='div' align='center'>Profit</Typography>
                        <Typography variant='subtitle2' align='center'>{data.lastMonth.profit} RON</Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          }

          {!!~props.user.permissions.indexOf('partnerDashboardServices') &&
            <Card className={classes.card}>
              <CardHeader
                title={<Typography variant='subtitle1'>Sumar servicii de laborator</Typography>}
              />
              <CardContent className={classes.cardContent}>
                <Grid container spacing={1}>
                  <Grid item xs={12}><Typography variant='subtitle2'>Pachete de servicii</Typography></Grid>
                  <Grid item xs={4}>
                    <Link to='/ResellerServices' className={classes.link}>
                      <Card className={classes.card}>
                        <CardContent className={`${classes.cardContent} ${classes.successMain}`}>
                          <Typography component='div' align='center'>Pachete de servicii cu profit pozitiv</Typography>
                          <Typography variant='subtitle2' align='center'>{data.servicePacks.filter(servicePack => +servicePack.price > +servicePack.priceSL).length}</Typography>
                        </CardContent>
                      </Card>
                    </Link>
                  </Grid>
                  <Grid item xs={4}>
                    <Link to='/ResellerServices' className={classes.link}>
                      <Card className={classes.card}>
                        <CardContent className={`${classes.cardContent} ${Boolean(data.servicePacks.filter(servicePack => parseInt(servicePack.price) === 0 || +servicePack.price === +servicePack.priceSL).length) ? classes.warningLight: ''}`}>
                          <Typography component='div' align='center'>Pachete de servicii cu profit zero</Typography>
                          <Typography variant='subtitle2' align='center'>{data.servicePacks.filter(servicePack => parseInt(servicePack.price) === 0 || +servicePack.price === +servicePack.priceSL).length}</Typography>
                        </CardContent>
                      </Card>
                    </Link>
                  </Grid>
                  <Grid item xs={4}>
                    <Link to='/ResellerServices' className={classes.link}>
                      <Card className={classes.card}>
                        <CardContent className={`${classes.cardContent} ${Boolean(data.servicePacks.filter(servicePack => parseInt(servicePack.price) > 0 && +servicePack.price < +servicePack.priceSL).length) ? classes.errorMain : ''}`}>
                          <Typography component='div' align='center'>Pachete de servicii cu profit negativ</Typography>
                          <Typography variant='subtitle2' align='center'>{data.servicePacks.filter(servicePack => parseInt(servicePack.price) > 0 && +servicePack.price < +servicePack.priceSL).length}</Typography>
                        </CardContent>
                      </Card>
                    </Link>
                  </Grid>
                </Grid>

                <Grid container spacing={1}>
                  <Grid item xs={12}><Typography variant='subtitle2'>Servicii</Typography></Grid>
                  <Grid item xs={4}>
                    <Link to='/ResellerServices' className={classes.link}>
                      <Card className={classes.card}>
                        <CardContent className={`${classes.cardContent} ${classes.successMain}`}>
                          <Typography component='div' align='center'>Servicii cu profit pozitiv</Typography>
                          <Typography variant='subtitle2' align='center'>{data.services.filter(service => +service.price > +service.priceSL).length}</Typography>
                        </CardContent>
                      </Card>
                    </Link>
                  </Grid>
                  <Grid item xs={4}>
                    <Link to='/ResellerServices' className={classes.link}>
                      <Card className={classes.card}>
                        <CardContent className={`${classes.cardContent} ${Boolean(data.services.filter(service => parseInt(service.price) === 0 || +service.price === +service.priceSL).length) ? classes.warningLight : ''}`}>
                          <Typography component='div' align='center'>Servicii cu profit zero</Typography>
                          <Typography variant='subtitle2' align='center'>{data.services.filter(service => parseInt(service.price) === 0 || +service.price === +service.priceSL).length}</Typography>
                        </CardContent>
                      </Card>
                    </Link>
                  </Grid>
                  <Grid item xs={4}>
                    <Link to='/ResellerServices' className={classes.link}>
                      <Card className={classes.card}>
                        <CardContent className={`${classes.cardContent} ${Boolean(data.services.filter(service => parseInt(service.price) > 0 && +service.price < +service.priceSL).length) ? classes.errorMain : ''}`}>
                          <Typography component='div' align='center'>Servicii cu profit negativ</Typography>
                          <Typography variant='subtitle2' align='center'>{data.services.filter(service => parseInt(service.price) > 0 && +service.price < +service.priceSL).length}</Typography>
                        </CardContent>
                      </Card>
                    </Link>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          }
        </Fragment>
      }

      {isLoaded && !!~props.user.permissions.indexOf('partnerAddReception') &&
        <Link to='/AddReception' className={classes.link}>
          <Fab variant='extended' className={classes.fab}>
            <AddIcon className={classes.fabIcon} />
            Adauga recoltare
          </Fab>
        </Link>
      }

      {isLoaded && !!~props.user.permissions.indexOf('partnerDashboardMedicalRecords') &&
        <Fragment>
          <Card className={classes.card}>
            <CardHeader
              title={<Typography variant='subtitle1' display='inline'>Sumar fise auto</Typography>}
            />
            <CardContent className={classes.cardContent}>
              <Warning display='block'>Numar fise neprezentate la sediul clinicii</Warning>
              <Warning display='block' color='primary'>Pentru Sunmed afisam numarul total de fise neprezentate la sediul clinicii</Warning>
              <Warning display='block'>Numar fise in lucru la sediul clinicii</Warning>
              <Warning display='block' color='primary'>Pentru Sunmed afisam numarul total de fise in lucru la sediul clinicii</Warning>
              <Warning display='block'>Situatia financiara sumara la zi</Warning>
              <Warning display='block'>Lista tuturor facturilor emise catre partener si statusul acestora (platite/neplatite).</Warning>
              <Warning display='block' color='primary'>Pentru Sunmed afisam doar facturile emise si neincasate, grupate pe parteneri + totalul lor.</Warning>
              <Warning display='block'>Numar si suma servicii nefacturate (pentru Sunmed, grupate pe partener)</Warning>
              <Warning display='block' color='primary'>Pentru Sunmed afisam numarul si suma serviciilor nefacturate, grupate pe partener + totalul lor</Warning>
              <Warning display='block'>Raport sumar fise adaugate (numar), prezentate (numar si suma de plata) si inchise (numar) pentru ziua curenta</Warning>
              <Warning display='block'>Raport sumar fise adaugate (numar), prezentate (numar si suma de plata) si inchise (numar) pentru ultimele 7 zile</Warning>
              <Warning display='block'>Raport sumar fise adaugate (numar), prezentate (numar si suma de plata) si inchise (numar) pentru luna curenta</Warning>
              <Warning display='block'>Raport sumar fise adaugate (numar), prezentate (numar si suma de plata) si inchise (numar) pentru luna anterioara</Warning>
              <Warning display='block'>Preturile negociate pentru fiecare tip de fisa in parte</Warning>
            </CardContent>
          </Card>
        </Fragment>
      }

      {isLoaded && !!~props.user.permissions.indexOf('partnerMedicalRecordAdd') &&
        <Link to='/MedicalRecords/Add' className={classes.link}>
          <Fab variant='extended' className={classes.fab}>
            <AddIcon className={classes.fabIcon} />
            Adauga fisa auto
          </Fab>
        </Link>
      }
    </Container>
  );
}